module.exports = __webpack_public_path__ + "static/img/sam-cover-img-15.6a7f7e9b.jpg";